import createIcon from '../../createIcon';

/**
 * @component @name PushPin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2IDlWNEgxN0MxNy41NSA0IDE4IDMuNTUgMTggM0MxOCAyLjQ1IDE3LjU1IDIgMTcgMkg3QzYuNDUgMiA2IDIuNDUgNiAzQzYgMy41NSA2LjQ1IDQgNyA0SDhWOUM4IDEwLjY2IDYuNjYgMTIgNSAxMlYxNEgxMC45N1YyMUwxMS45NyAyMkwxMi45NyAyMVYxNEgxOVYxMkMxNy4zNCAxMiAxNiAxMC42NiAxNiA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PushPin = createIcon('PushPin', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9Z',
      key: 'xhyt7d',
    },
  ],
]);

export default PushPin;
